export const USER_TYPE_SYSTEM_ADMIN = {
    id: 99,
    name: "System Admin",
};

export const USER_TYPE_LIST = [
    {
        id: 3,
        name: "User Manager",
    },
    {
        id: 1,
        name: "Site Admin",
    },
    {
        id: 2,
        name: "Read Only Admin",
    },
    {
        id: 0,
        name: "HCP User",
    },
];

export const ADMIN_USER_TYPE = {
    99: "System Admin",
    1: "Site Admin",
    19: "Basic Login Admin",
    3: "User Manager",
};

export const ADMIN_TYPES = {
    SITEADMIN: "site-admin",
    USERMANAGER: "user-manager",
    SYSTEMADMIN: "system-admin",
};
